import React from 'react';
import { CLASSIC_RIVALS } from './four12Characters';
import { RANDOM_RIVAL } from './useClassicRival';

// Selector de rival debajo del personaje (modo clásico vs bot). "Aleatorio" cambia de rival
// en cada partida; elegir uno lo deja fijo.
const RivalPicker = ({ choice, onChange }) => (
  <label className="rival-picker">
    <span className="rival-picker__label">Rival</span>
    <select
      className="rival-picker__select"
      value={choice}
      onChange={e => onChange(e.target.value)}
    >
      <option value={RANDOM_RIVAL}>🎲 Aleatorio</option>
      {CLASSIC_RIVALS.map(r => (
        <option key={r.id} value={r.id}>{r.nombre}</option>
      ))}
    </select>
  </label>
);

export default RivalPicker;
